export * from './gameGroups.service';
import { GameGroupsService } from './gameGroups.service';
export * from './report.service';
import { ReportService } from './report.service';
export const APIS = [GameGroupsService, ReportService];
